import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AccessControl,
  CustomWarningModal,
  DeleteModal,
  translateText,
  useProduct
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Heading, Tippy } from '@superops/ui-design-system';

function ActionsCell({ cell }) {
  const { actions } = cell?.column;
  const rowData = cell.row.original;

  const isMSPProduct = useProduct('MSP');

  const isDefault: boolean =
    rowData?.serviceTypeItem?.hourlyServiceTypeItem?.defaultItem;

  if (
    !!rowData?.integrationState?.pax8 ||
    rowData?.serviceTypeItem?.defaultUsageType === 'LATE_FEE'
  ) {
    return null;
  }

  if (rowData?.status === 'INACTIVE') {
    return (
      <div className="deleteItem cursor-pointer fx actr g5 action-button">
        <AccessControl
          roleToCheck="serviceCatalog.edit"
          render={
            <Tippy
              title={translateText('app.common.restore')}
              duration={250}
              delay={200}
              arrow={false}
              theme="dark"
            >
              <span
                className="fx actr"
                onClick={() => actions?.toggleStatus(cell.row.original)}
              >
                <SVGIcon name="Reset" />
              </span>
            </Tippy>
          }
        />
        {!isDefault && (
          <AccessControl
            roleToCheck="serviceCatalog.delete"
            render={
              <Tippy
                title={translateText('common.delete')}
                duration={250}
                delay={200}
                arrow={false}
                theme="dark"
              >
                <DeleteModal
                  description={translateText(
                    'admin.serviceCatalog.item.delete.confirmation.description'
                  )}
                  handleDeleteConfirmation={() =>
                    actions?.delete(cell.row.original)
                  }
                  title={translateText('app.deleteConfirmation.header')}
                  modalActivator={
                    <span className="fx actr">
                      <SVGIcon name="Delete" />
                    </span>
                  }
                />
              </Tippy>
            }
          />
        )}
      </div>
    );
  }

  return (
    <div className="deleteItem cursor-pointer fx actr g5 action-button">
      <AccessControl
        roleToCheck="serviceCatalog.add"
        render={
          <Tippy
            title={translateText('admin.serviceCatalog.item.clone')}
            duration={250}
            delay={200}
            arrow={false}
            theme="dark"
          >
            <span
              className="fx actr"
              onClick={() => actions?.clone(cell.row.original)}
            >
              <SVGIcon name="CopyClipboard" />
            </span>
          </Tippy>
        }
      />
      {isMSPProduct && !isDefault && (
        <AccessControl
          roleToCheck="serviceCatalog.edit"
          render={
            <Tippy
              title={translateText('app.common.mark.inactive')}
              duration={250}
              delay={200}
              arrow={false}
              theme="dark"
            >
              <CustomWarningModal
                content={
                  <div className="fx g10">
                    <SVGIcon name="WarningIcon" size="xl" color="#F07602" />
                    <div className="fx fcol g10 pb20">
                      <Heading element="h1">
                        <FormattedMessage id="admin.serviceCatalog.item.make.inactive.confirmation.title" />
                      </Heading>
                      <div>
                        <FormattedMessage id="admin.serviceCatalog.item.make.inactive.confirmation.description" />
                      </div>
                    </div>
                  </div>
                }
                modalActivator={
                  <span className="fx actr">
                    <SVGIcon name="Restrict" />
                  </span>
                }
                primaryBtnText="Yes, Proceed"
                primaryBtnIcon="Restrict"
                onConfirmation={() => actions?.toggleStatus(cell.row.original)}
              />
            </Tippy>
          }
        />
      )}
    </div>
  );
}

export default ActionsCell;
